import { LoaderCircleIcon } from 'lucide-react';

const Loading = () => {
  return (
    <div>
      <LoaderCircleIcon />
    </div>
  );
};

export default Loading;
